import React, { useEffect, useState, useMemo } from 'react';
import { PageTitle } from '../../../../_metronic/layout/core';
import { EntrevistaDetallesHeader } from './detallesHeader';
import { useParams } from 'react-router-dom';
import { Button, Col, Form, Row } from 'react-bootstrap';
import SpinnerButton from '../../../Components/SpinnerButton';
import { Modal, ProgressBar } from 'react-bootstrap';
import ReactPlayer from 'react-player';
import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
import Dropzone from 'react-dropzone';
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import axios from 'axios';
import { useAuth } from '../../../modules/auth';
import logAction from '../../../Utils/log';

const API_URL = process.env.REACT_APP_API_URL
type dataType = {
  nombre: '',
  nombreOriginal: '',
  categoria: ''
}
const EntrevistaArchivos: React.FC = () => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [listAudios, setAudios] = useState<any[]>([]);
  const [listFiles, setFiles] = useState<any[]>([]);
  const [uploadFiles, setUploadFiles] = useState<any[]>([]);
  const [consetimientoInf, setConsentimientoInf] = useState<any[]>([]);
  const [formatoEntrevista, setFormatoEntrevista] = useState<any[]>([]);

  const [transcripcionWhisper, setTranscripcionWhisper] = useState<any[]>([]);
  const [transcripcionLimpio, setTranscripcionLimpio] = useState<any[]>([]);
  const [transcripcionAnotaciones, setTranscripcionAnotaciones] = useState<any[]>([]);
  const [transcripcionInvestigador, setTranscripcionInvestigador] = useState<any[]>([]);
  const [transcripcionWhisperv2, setTranscripcionWhisperv2] = useState<any[]>([]);

  const [progressBars, setProgressBars] = useState<any[]>([]);
  const [progressBarsConsentimiento, setProgressBarsConsentimiento] = useState<any[]>([]);
  const [progressBarsFormato, setProgressBarsFormato] = useState<any[]>([]);
  const [progressBarsWhisper, setProgressBarsWhisper] = useState<any[]>([]);
  const [progressBarsLimpio, setProgressBarsLimpio] = useState<any[]>([]);
  const [progressBarsAnotaciones, setProgressBarsAnotaciones] = useState<any[]>([]);
  const [progressBarsInvestigador, setProgressBarsInvestigador] = useState<any[]>([]);
  const [progressBarsWhisperv2, setProgressBarsWhisperv2] = useState<any[]>([]);

  const [show, setShow] = useState(false);
  const [playFile, setPlayFile] = useState<String>("");
  const { id } = useParams();
  const auth = JSON.parse(localStorage.getItem("kt-auth-react-v")!);
  const { currentUser } = useAuth();

  // On file select (from the pop up)
  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      event.target.value = "";
    }
  };

  const downloadFile = async (nombre: string, nombreOriginal: string) => {
    try {
      const response = await fetch(`${API_URL}/files/download/${nombre}/${nombreOriginal}`, {
        headers: {
          'Content-Type': "application/json",
          'auth-token': auth.api_token,
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const result = await response.json()
      window.open(result.url, '_blank')
    } catch (err) {
      console.log(err);
    };
  }

  const getListFiles = async () => {
    try {
      const response = await fetch(`${API_URL}/entrevista/getById`, {
        method: 'POST',
        body: JSON.stringify({ "id": id }),
        headers: {
          'Content-Type': "application/json",
          'auth-token': auth.api_token,
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const files = await response.json()
      setFiles(files.files)
      setAudios(files.audios)
    } catch (err) {
      console.log(err);
    };
  }

  useEffect(() => {
    getListFiles();
  }, []);

  const axiosInstance = axios.create({
    baseURL: `${API_URL}`,
  })

  const onFileUpload = async (type: number) => {
    let prog: any[];
    let files: any[];
    if (type == 1) {
      prog = [...progressBars];
      const uploadPromises = uploadFiles.map(async (file, index) => {
        const formData = new FormData();
        formData.append('myFile', file, file.name);
        try {
          const response = await axiosInstance.post('/files/uploadFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'auth-token': auth.api_token,
              id: id!,
              type: type
            },
            onUploadProgress: (data) => {
              prog[index] = Math.round((100 * data.loaded) / data.total);
              setProgressBars([...prog]);
            },
          });
          logAction(currentUser?.username, `Subó el archivo de Entrevista: ${file.name}`)
          return response.data;
        } catch (err) {
          logAction(currentUser?.username, `Ocurrió un error al subir el archivo: ${file.name}`)
          console.log(err);
        }
      });

      await Promise.all(uploadPromises);
      await alert("Se subieron los archivos");

      setUploadFiles([]);
      setProgressBars([]);
    }
    if (type == 2) {
      prog = [...progressBarsConsentimiento];
      const uploadPromises = consetimientoInf.map(async (file, index) => {
        const formData = new FormData();
        formData.append('myFile', file, file.name);
        try {
          const response = await axiosInstance.post('/files/uploadFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'auth-token': auth.api_token,
              id: id!,
              type: type
            },
            onUploadProgress: (data) => {
              prog[index] = Math.round((100 * data.loaded) / data.total);
              setProgressBars([...prog]);
            },
          });
          logAction(currentUser?.username, `Subó el archivo de Consentimiento Informado: ${file.name}`)
          return response.data;
        } catch (err) {
          logAction(currentUser?.username, `Ocurrió un error al subir el archivo: ${file.name}`)
          console.log(err);
        }
      });

      await Promise.all(uploadPromises);
      await alert("Se subieron los archivos");
      setConsentimientoInf([]);
      setProgressBarsConsentimiento([]);
    }
    if (type == 3) {
      prog = [...progressBarsFormato];
      const uploadPromises = formatoEntrevista.map(async (file, index) => {
        const formData = new FormData();
        formData.append('myFile', file, file.name);
        try {
          const response = await axiosInstance.post('/files/uploadFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'auth-token': auth.api_token,
              id: id!,
              type: type
            },
            onUploadProgress: (data) => {
              prog[index] = Math.round((100 * data.loaded) / data.total);
              setProgressBars([...prog]);
            },
          });
          logAction(currentUser?.username, `Subó el archivo de Formato de Entrevista: ${file.name}`)
          return response.data;
        } catch (err) {
          logAction(currentUser?.username, `Ocurrió un error al subir el archivo: ${file.name}`)
          console.log(err);
        }
      });

      await Promise.all(uploadPromises);
      await alert("Se subieron los archivos");
      setFormatoEntrevista([]);
      setProgressBarsFormato([]);
    }

    //EMPIEZAN LOS DEMAS

    if (type == 4) {
      prog = [...progressBarsWhisper];
      const uploadPromises = transcripcionWhisper.map(async (file, index) => {
        const formData = new FormData();
        formData.append('myFile', file, file.name);
        try {
          const response = await axiosInstance.post('/files/uploadFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'auth-token': auth.api_token,
              id: id!,
              type: type
            },
            onUploadProgress: (data) => {
              prog[index] = Math.round((100 * data.loaded) / data.total);
              setProgressBarsWhisper([...prog]);
            },
          });
          logAction(currentUser?.username, `Subó el archivo de Transcripción: ${file.name}`)
          return response.data;
        } catch (err) {
          logAction(currentUser?.username, `Ocurrió un error al subir el archivo: ${file.name}`)
          console.log(err);
        }
      });

      await Promise.all(uploadPromises);
      await alert("Se subieron los archivos");
      setTranscripcionWhisper([]);
      setProgressBarsWhisper([]);
    }

    if (type == 5) {
      prog = [...progressBarsLimpio];
      const uploadPromises = transcripcionLimpio.map(async (file, index) => {
        const formData = new FormData();
        formData.append('myFile', file, file.name);
        try {
          const response = await axiosInstance.post('/files/uploadFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'auth-token': auth.api_token,
              id: id!,
              type: type
            },
            onUploadProgress: (data) => {
              prog[index] = Math.round((100 * data.loaded) / data.total);
              setProgressBarsLimpio([...prog]);
            },
          });
          logAction(currentUser?.username, `Subó el archivo de Transcripción en Limpio: ${file.name}`)
          return response.data;
        } catch (err) {
          logAction(currentUser?.username, `Ocurrió un error al subir el archivo: ${file.name}`)
          console.log(err);
        }
      });

      await Promise.all(uploadPromises);
      await alert("Se subieron los archivos");
      setTranscripcionLimpio([]);
      setProgressBarsLimpio([]);
    }

    if (type == 6) {
      prog = [...progressBarsAnotaciones];
      const uploadPromises = transcripcionAnotaciones.map(async (file, index) => {
        const formData = new FormData();
        formData.append('myFile', file, file.name);
        try {
          const response = await axiosInstance.post('/files/uploadFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'auth-token': auth.api_token,
              id: id!,
              type: type
            },
            onUploadProgress: (data) => {
              prog[index] = Math.round((100 * data.loaded) / data.total);
              setProgressBarsAnotaciones([...prog]);
            },
          });
          logAction(currentUser?.username, `Subó el archivo de Transcripción con Anotaciones: ${file.name}`)
          return response.data;
        } catch (err) {
          logAction(currentUser?.username, `Ocurrió un error al subir el archivo: ${file.name}`)
          console.log(err);
        }
      });

      await Promise.all(uploadPromises);
      await alert("Se subieron los archivos");
      setTranscripcionAnotaciones([]);
      setProgressBarsAnotaciones([]);
    }

    if (type == 7) {
      prog = [...progressBarsInvestigador];
      const uploadPromises = transcripcionInvestigador.map(async (file, index) => {
        const formData = new FormData();
        formData.append('myFile', file, file.name);
        try {
          const response = await axiosInstance.post('/files/uploadFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'auth-token': auth.api_token,
              id: id!,
              type: type
            },
            onUploadProgress: (data) => {
              prog[index] = Math.round((100 * data.loaded) / data.total);
              setProgressBarsInvestigador([...prog]);
            },
          });
          logAction(currentUser?.username, `Subó el archivo de Transcripción Investigador: ${file.name}`)
          return response.data;
        } catch (err) {
          logAction(currentUser?.username, `Ocurrió un error al subir el archivo: ${file.name}`)
          console.log(err);
        }
      });

      await Promise.all(uploadPromises);
      await alert("Se subieron los archivos");
      setTranscripcionInvestigador([]);
      setProgressBarsInvestigador([]);
    }

    if (type == 8) {
      prog = [...progressBarsWhisperv2];
      const uploadPromises = transcripcionWhisperv2.map(async (file, index) => {
        const formData = new FormData();
        formData.append('myFile', file, file.name);
        try {
          const response = await axiosInstance.post('/files/uploadFile', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              'auth-token': auth.api_token,
              id: id!,
              type: type
            },
            onUploadProgress: (data) => {
              prog[index] = Math.round((100 * data.loaded) / data.total);
              setProgressBarsWhisperv2([...prog]);
            },
          });
          logAction(currentUser?.username, `Subó el archivo de Whisper v2: ${file.name}`)
          return response.data;
        } catch (err) {
          logAction(currentUser?.username, `Ocurrió un error al subir el archivo: ${file.name}`)
          console.log(err);
        }
      });

      await Promise.all(uploadPromises);
      await alert("Se subieron los archivos");
      setTranscripcionWhisperv2([]);
      setProgressBarsWhisperv2([]);
    }

    getListFiles();
  };

  const isAudio = (mime: String) => {
    const tipo = mime.split("/");
    let valor = false;
    if (tipo[0] === "audio" || tipo[0] === "video")
      valor = true
    return valor;
  }

  const fileData = () => {
    const moment = require('moment');
    return (
      <div >
        {uploadFiles.map((file, index) => (
          <div className='col-md-12' key={index}>
            <img src={toAbsoluteUrl('/media/svg/files/upload.svg')} />
            <p>Nombre del Archivo: {file.name}</p>
            <ProgressBar animated now={progressBars[index]} />
          </div>
        ))}
      </div>
    );
  };

  const consentInf = () => {
    const moment = require('moment');
    return (
      <div>
        {consetimientoInf.map((file, index) => (
          <div className='col-md-12' key={index}>
            <img src={toAbsoluteUrl('/media/svg/files/upload.svg')} />
            <p>Nombre del Archivo: {file.name}</p>
            <ProgressBar animated now={progressBarsConsentimiento[index]} />
          </div>
        ))}
      </div>
    );
  };

  const formatoEnt = () => {
    const moment = require('moment');
    return (
      <div>
        {formatoEntrevista.map((file, index) => (
          <div className='col-md-12' key={index}>
            <img src={toAbsoluteUrl('/media/svg/files/upload.svg')} />
            <p>Nombre del Archivo: {file.name}</p>
            <ProgressBar animated now={progressBarsFormato[index]} />
          </div>
        ))}
      </div>
    );
  };

  const transWhisper = () => {
    const moment = require('moment');
    return (
      <div>
        {transcripcionWhisper.map((file, index) => (
          <div className='col-md-12' key={index}>
            <img src={toAbsoluteUrl('/media/svg/files/upload.svg')} />
            <p>Nombre del Archivo: {file.name}</p>
            <ProgressBar animated now={progressBarsWhisper[index]} />
          </div>
        ))}
      </div>
    );
  };

  const transV2 = () => {
    const moment = require('moment');
    return (
      <div>
        {transcripcionWhisperv2.map((file, index) => (
          <div className='col-md-12' key={index}>
            <img src={toAbsoluteUrl('/media/svg/files/upload.svg')} />
            <p>Nombre del Archivo: {file.name}</p>
            <ProgressBar animated now={progressBarsWhisperv2[index]} />
          </div>
        ))}
      </div>
    );
  };

  const transLimpio = () => {
    const moment = require('moment');
    return (
      <div>
        {transcripcionLimpio.map((file, index) => (
          <div className='col-md-12' key={index}>
            <img src={toAbsoluteUrl('/media/svg/files/upload.svg')} />
            <p>Nombre del Archivo: {file.name}</p>
            <ProgressBar animated now={progressBarsLimpio[index]} />
          </div>
        ))}
      </div>
    );
  };

  const transAnotaciones = () => {
    const moment = require('moment');
    return (
      <div>
        {transcripcionAnotaciones.map((file, index) => (
          <div className='col-md-12' key={index}>
            <img src={toAbsoluteUrl('/media/svg/files/upload.svg')} />
            <p>Nombre del Archivo: {file.name}</p>
            <ProgressBar animated now={progressBarsAnotaciones[index]} />
          </div>
        ))}
      </div>
    );
  };

  const transInvestigador = () => {
    const moment = require('moment');
    return (
      <div>
        {transcripcionInvestigador.map((file, index) => (
          <div className='col-md-12' key={index}>
            <img src={toAbsoluteUrl('/media/svg/files/upload.svg')} />
            <p>Nombre del Archivo: {file.name}</p>
            <ProgressBar animated now={progressBarsInvestigador[index]} />
          </div>
        ))}
      </div>
    );
  };

  const play = async (fileId: React.SetStateAction<String>) => {
    setShow(true)
    const filePlay = fileId
    setPlayFile(filePlay)
    
    logAction(currentUser?.username, `Escuchando el archivo: ${fileId}`);
    /*
    const params = {id: entrevistaId, fileId: fileId}
    try {
      const response = await fetch(`${API_URL}/files/play/${id}/${fileId}`, {
        headers: {
          'auth-token': auth.api_token,
          'Content-Type': 'audio/*',
        }
      });
      if (!response.ok) {
        throw Error(response.statusText);
      }
      const data = await response.json();
      setPlayFile(data)
      console.log(data)
    } catch (err) {
      console.log(err)
    }*/
  }

  const xhrSetup = function (xhr: XMLHttpRequest | XMLHttpRequestUpload) {
    const request = xhr as XMLHttpRequest;
    request.setRequestHeader('Authorization', auth.api_token);
  };

  return (
    <>
      <PageTitle>Archivos de la Entrevista</PageTitle>
      <div className='card mb-5 mb-xl-10'>
        <div className="card-header">
          <EntrevistaDetallesHeader id={id} />
        </div>
        <Row className='g-6 g-xl-9 mb-6 mb-xl-9'>
          {listAudios.map(post =>
            <div className='col-4 col-sm-4 col-xl' key={post._id} onClick={() => { if (isAudio(post.tipo)) { play(`${post.nombre}`) } else { downloadFile(`${post.nombre}`, `${post.nombreOriginal}`) } }}>
              <Card4 icon={`/media/svg/files/${post.extension}.svg`} title={post.nombreOriginal} description={post.fechaSubido} category={post.categoria} />
            </div>
            /* <Button key={post._id} onClick={() => { play(`${post.nombre}`) }}>Play {post.nombreOriginal}</Button> */
          )}
          {listFiles.map(post => (currentUser?.role == 3 && post.categoria == "Transcripción Whisper") &&
            <div className='col-4 col-sm-4 col-xl' key={post._id} onClick={() => { if (isAudio(post.tipo)) { play(`${post.nombre}`) } else { downloadFile(`${post.nombre}`, `${post.nombreOriginal}`) } }}>
              <Card4 icon={`/media/svg/files/${post.extension}.svg`} title={post.nombreOriginal} description={post.fechaSubido} category={post.categoria} />
            </div>
            /* <Button key={post._id} onClick={() => { play(`${post.nombre}`) }}>Play {post.nombreOriginal}</Button> */
          )}
          {listFiles.map(post => currentUser?.role != 3 &&
            <div className='col-4 col-sm-4 col-xl' key={post._id} onClick={() => { if (isAudio(post.tipo)) { play(`${post.nombre}`) } else { downloadFile(`${post.nombre}`, `${post.nombreOriginal}`) } }}>
              <Card4 icon={`/media/svg/files/${post.extension}.svg`} title={post.nombreOriginal} description={post.fechaSubido} category={post.categoria} />
            </div>
            /* <Button key={post._id} onClick={() => { play(`${post.nombre}`) }}>Play {post.nombreOriginal}</Button> */
          )}
        </Row>
        <Row>
          {currentUser?.role !== 3 &&
            <Col md={4}>
              <div className='card-body border-top p-9'>
                <div className='card card-custom card-flush'>
                  <div className="card-header">
                    <h3 className="card-title">Subir Audios</h3>
                  </div>
                  <div className="card-body border-dashed center">
                    <Dropzone
                      onDrop={acceptedFiles => setUploadFiles(acceptedFiles)}
                      accept={{ 'audio/*': ['.mp3', '.mp4', '.m4a', '.wma', '.wav'], 'video/*': ['.mp4'] }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div {...getRootProps()} style={{ textAlign: 'center' }}>
                            <input {...getInputProps()} />
                            <p><i className='bi bi-file-earmark-plus fs-3x'></i></p>
                            <p>Arrastra archivos para subir o da click para subir uno o varios archivos</p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    {fileData()}
                  </div>
                  <div className="card-footer"></div>
                </div>
                <Row>
                  <SpinnerButton className="mt-7 col-md-6" onClick={() => { onFileUpload(1) }} item={false}>Subir</SpinnerButton>
                  <SpinnerButton className="btn-danger mt-7 col-md-6" onClick={() => { setUploadFiles([]); setProgressBars([]) }} item={false}>Cancelar</SpinnerButton>
                </Row>
              </div>
            </Col>
          }
          {currentUser?.role !== 3 &&
            <Col md={4}>
              <div className='card-body border-top p-9'>
                <div className='card card-custom card-flush'>
                  <div className="card-header">
                    <h3 className="card-title">Subir Consentimiento Informado</h3>
                  </div>
                  <div className="card-body border-dashed center">
                    <Dropzone onDrop={acceptedFiles => setConsentimientoInf(acceptedFiles)}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div {...getRootProps()} style={{ textAlign: 'center' }}>
                            <input {...getInputProps()} />
                            <p><i className='bi bi-file-earmark-plus fs-3x'></i></p>
                            <p>Arrastra archivos para subir o da click para subir uno o varios archivos</p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    {consentInf()}
                  </div>
                  <div className="card-footer"></div>
                </div>
                <Row>
                  <SpinnerButton className="mt-7 col-md-6" onClick={() => { onFileUpload(2) }} item={false}>Subir</SpinnerButton>
                  <SpinnerButton className="btn-danger mt-7 col-md-6" onClick={() => { setConsentimientoInf([]); setProgressBarsConsentimiento([]) }} item={false}>Cancelar</SpinnerButton>
                </Row>
              </div>
            </Col>
          }
          {currentUser?.role !== 3 &&
            <Col md={4}>
              <div className='card-body border-top p-9'>
                <div className='card card-custom card-flush'>
                  <div className="card-header">
                    <h3 className="card-title">Subir Ficha de Entrevista</h3>
                  </div>
                  <div className="card-body border-dashed center">
                    <Dropzone onDrop={acceptedFiles => setFormatoEntrevista(acceptedFiles)}>
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div {...getRootProps()} style={{ textAlign: 'center' }}>
                            <input {...getInputProps()} />
                            <p><i className='bi bi-file-earmark-plus fs-3x'></i></p>
                            <p>Arrastra archivos para subir o da click para subir uno o varios archivos</p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    {formatoEnt()}
                  </div>
                  <div className="card-footer"></div>
                </div>
                <Row>
                  <SpinnerButton className="mt-7 col-md-6" onClick={() => { onFileUpload(3) }} item={false}>Subir</SpinnerButton>
                  <SpinnerButton className="btn-danger mt-7 col-md-6" onClick={() => { setFormatoEntrevista([]); setProgressBarsFormato([]) }} item={false}>Cancelar</SpinnerButton>
                </Row>
              </div>
            </Col>
          }
          {currentUser?.role !== 3 &&
            <Col md={4}>
              <div className='card-body border-top p-9'>
                <div className='card card-custom card-flush'>
                  <div className="card-header">
                    <h3 className="card-title">Subir Transcripción Whisper</h3>
                  </div>
                  <div className="card-body border-dashed center">
                    <Dropzone onDrop={acceptedFiles => setTranscripcionWhisper(acceptedFiles)}
                      accept={{ 'text/plain': ['.txt'] }}
                    >
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div {...getRootProps()} style={{ textAlign: 'center' }}>
                            <input {...getInputProps()} />
                            <p><i className='bi bi-file-earmark-plus fs-3x'></i></p>
                            <p>Arrastra archivos para subir o da click para subir uno o varios archivos</p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    {transWhisper()}
                  </div>
                  <div className="card-footer"></div>
                </div>
                <Row>
                  <SpinnerButton className="mt-7 col-md-6" onClick={() => { onFileUpload(4) }} item={false}>Subir</SpinnerButton>
                  <SpinnerButton className="btn-danger mt-7 col-md-6" onClick={() => { setTranscripcionWhisper([]); setProgressBarsWhisper([]) }} item={false}>Cancelar</SpinnerButton>
                </Row>
              </div>
            </Col>
          }
          <Col md={4}>
            <div className='card-body border-top p-9'>
              <div className='card card-custom card-flush'>
                <div className="card-header">
                  <h3 className="card-title">Subir Transcripción en limpio</h3>
                </div>
                <div className="card-body border-dashed center">
                  <Dropzone onDrop={acceptedFiles => setTranscripcionLimpio(acceptedFiles)}
                    accept={{ 'text/plain': ['.txt'] }}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div {...getRootProps()} style={{ textAlign: 'center' }}>
                          <input {...getInputProps()} />
                          <p><i className='bi bi-file-earmark-plus fs-3x'></i></p>
                          <p>Arrastra archivos para subir o da click para subir uno o varios archivos</p>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                  {transLimpio()}
                </div>
                <div className="card-footer"></div>
              </div>
              <Row>
                <SpinnerButton className="mt-7 col-md-6" onClick={() => { onFileUpload(5) }} item={false}>Subir</SpinnerButton>
                <SpinnerButton className="btn-danger mt-7 col-md-6" onClick={() => { setTranscripcionLimpio([]); setProgressBarsLimpio([]) }} item={false}>Cancelar</SpinnerButton>
              </Row>
            </div>
          </Col>
          <Col md={4}>
            <div className='card-body border-top p-9'>
              <div className='card card-custom card-flush'>
                <div className="card-header">
                  <h3 className="card-title">Subir Transcripción Whisper 2.0</h3>
                </div>
                <div className="card-body border-dashed center">
                  <Dropzone onDrop={acceptedFiles => setTranscripcionWhisperv2(acceptedFiles)}>
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div {...getRootProps()} style={{ textAlign: 'center' }}>
                          <input {...getInputProps()} />
                          <p><i className='bi bi-file-earmark-plus fs-3x'></i></p>
                          <p>Arrastra archivos para subir o da click para subir uno o varios archivos</p>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                  {transV2()}
                </div>
                <div className="card-footer"></div>
              </div>
              <Row>
                <SpinnerButton className="mt-7 col-md-6" onClick={() => { onFileUpload(8) }} item={false}>Subir</SpinnerButton>
                <SpinnerButton className="btn-danger mt-7 col-md-6" onClick={() => { setTranscripcionWhisperv2([]); setProgressBarsWhisperv2([]) }} item={false}>Cancelar</SpinnerButton>
              </Row>
            </div>
          </Col>
          <Col md={4}>
            <div className='card-body border-top p-9'>
              <div className='card card-custom card-flush'>
                <div className="card-header">
                  <h3 className="card-title">Subir Transcripción con Anotaciones</h3>
                </div>
                <div className="card-body border-dashed center">
                  <Dropzone onDrop={acceptedFiles => setTranscripcionAnotaciones(acceptedFiles)}>
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div {...getRootProps()} style={{ textAlign: 'center' }}>
                          <input {...getInputProps()} />
                          <p><i className='bi bi-file-earmark-plus fs-3x'></i></p>
                          <p>Arrastra archivos para subir o da click para subir uno o varios archivos</p>
                        </div>
                      </section>
                    )}
                  </Dropzone>
                  {transAnotaciones()}
                </div>
                <div className="card-footer"></div>
              </div>
              <Row>
                <SpinnerButton className="mt-7 col-md-6" onClick={() => { onFileUpload(6) }} item={false}>Subir</SpinnerButton>
                <SpinnerButton className="btn-danger mt-7 col-md-6" onClick={() => { setTranscripcionAnotaciones([]); setProgressBarsAnotaciones([]) }} item={false}>Cancelar</SpinnerButton>
              </Row>
            </div>
          </Col>
          {currentUser?.role !== 3 &&
            <Col md={4}>
              <div className='card-body border-top p-9'>
                <div className='card card-custom card-flush'>
                  <div className="card-header">
                    <h3 className="card-title">Subir transcripción con Apuntes del Investigador</h3>
                  </div>
                  <div className="card-body border-dashed center">
                    <Dropzone onDrop={acceptedFiles => setTranscripcionInvestigador(acceptedFiles)}>
                      {({ getRootProps, getInputProps }) => (
                        <section>
                          <div {...getRootProps()} style={{ textAlign: 'center' }}>
                            <input {...getInputProps()} />
                            <p><i className='bi bi-file-earmark-plus fs-3x'></i></p>
                            <p>Arrastra archivos para subir o da click para subir uno o varios archivos</p>
                          </div>
                        </section>
                      )}
                    </Dropzone>
                    {transInvestigador()}
                  </div>
                  <div className="card-footer"></div>
                </div>
                <Row>
                  <SpinnerButton className="mt-7 col-md-6" onClick={() => { onFileUpload(7) }} item={false}>Subir</SpinnerButton>
                  <SpinnerButton className="btn-danger mt-7 col-md-6" onClick={() => { setTranscripcionInvestigador([]); setProgressBarsInvestigador([]) }} item={false}>Cancelar</SpinnerButton>
                </Row>
              </div>
            </Col>
          }
        </Row>
      </div>
      <Modal show={show} onHide={() => { setShow(false); setPlayFile("sample-3s.mp3"); }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Archivo {playFile}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReactPlayer
            url={`${API_URL}/files/play/${playFile}`}
            controls={true}
            config={{
              file: {
                hlsOptions: {
                  forceHLS: true,
                  debug: false,
                  xhrSetup: xhrSetup
                },
                attributes: { controlsList: 'nodownload' }
              },
            }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}

export { EntrevistaArchivos };
